import React, { useState } from 'react'
import axios from "axios";
import Loader from "../components/Loader";
import Error from "../components/Error";
import { useNavigate } from "react-router-dom";
function Login() {
	const [loading, setloading] = useState(false);
	const [error, seterror] = useState();
	const navigate = useNavigate();
      const [email, setemail] = useState('');
        const [password, setpassword] = useState('');
       

         async function Submit(){

    const user={ 

    email,
    password,
 
    }
	try {
	setloading(true);
	const result = (
		await axios.post("https://online-hotels-booking-system-server.vercel.app/api/users/login", user)).data
		setloading(false);
		localStorage.setItem("currentuser", JSON.stringify(result));
	
			navigate("/home");
} catch (error) {
	setloading(false);
	seterror(true);
	console.log(error);
	
}
    console.log(user)
      
          }
  return (
		<div>
			{loading && (<Loader/>)}
			<div className="row justify-content-center mt-5">
				<div className="col-md-5">
					{error && (<Error/>)}
					<div className="bs">
						<h1>Login</h1>

						<input
							type="email"
							required
							className="form-control"
							placeholder="email"
							value={email}
							onChange={(e) => {
								setemail(e.target.value);
							}}
						/>
						<input
							type="password"
							required
							className="form-control"
							placeholder="password"
							value={password}
							onChange={(e) => {
								setpassword(e.target.value);
							}}
						/>
					
						<button className="btn btn-primary mt-3" onClick={Submit}>
							Login
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Login